module.exports = __webpack_public_path__ + "img/SketchPng453fd2c0c642ac50a1143be78e7603c3620c65ab114515aff7f131a5eab9927b.1316bf73.png";